import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { ButtonFilled } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import redirect from '../../../lib/redirect';
import { subjectDeleteMutation } from '../../../queries/subjects';
import {
  SubjectDeleteMutation,
  SubjectDeleteMutationVariables
} from '../../../queries/__generated__/SubjectDeleteMutation';

interface SubjectDeleteProps {
  subjectId: string;
}

const SubjectDelete: React.FC<SubjectDeleteProps> = ({ subjectId }) => {
  const { reloadNotebook } = useContext(NotebookContext);

  const deleteSubject = async () => {
    await client.mutate<SubjectDeleteMutation, SubjectDeleteMutationVariables>({
      mutation: subjectDeleteMutation,
      variables: { id: subjectId }
    });

    reloadNotebook();
    redirect('/notebook');
  };

  return (
    <div className="min-vh-100 flex flex-column items-center justify-center pa3">
      <div className="tc mw6">
        <p className="serif lh-copy measure-narrow mt0 mb4">
          You’ll lose all your data for this subject. Are you sure you want to delete it?
        </p>

        <ButtonFilled className="mb3" onClick={deleteSubject} data-testid="confirm-delete-button">
          Yes, Delete
        </ButtonFilled>
        <Link
          className="db f6 blue hover-navy"
          to={`/notebook/subject/${subjectId}/settings`}
          data-testid="cancel-delete-button"
        >
          No, Don’t Delete
        </Link>
      </div>
    </div>
  );
};

export default SubjectDelete;
